"use client";

import { useEffect, useRef } from "react";
import { useTheme } from "next-themes";
import { useAuth } from "@/contexts/AuthContext";

type AppTheme = "light" | "dark";

export default function UserThemeSync() {
  const { user } = useAuth();
  const { resolvedTheme, setTheme } = useTheme();
  const lastAppliedTheme = useRef<AppTheme | null>(null);

  const userTheme: AppTheme = user?.theme === "dark" ? "dark" : "light";

  useEffect(() => {
    const currentTheme: AppTheme =
      resolvedTheme === "dark" ? "dark" : "light";

    if (currentTheme === userTheme) {
      lastAppliedTheme.current = userTheme;
      return;
    }

    if (lastAppliedTheme.current === userTheme) return;

    lastAppliedTheme.current = userTheme;
    setTheme(userTheme);
  }, [resolvedTheme, setTheme, userTheme]);

  return null;
}